import { service } from './service'; // 导出送货单list

export function LoadData(params) {
  return service({
    url: 'SendMail/LoadData',
    method: 'get',
    params: params
  });
} // 保存邮件配置

export function SaveData(data) {
  return service({
    url: 'SendMail/SaveData',
    method: 'post',
    data: data
  });
} // 邮件测试

export function SendEmail(data) {
  return service({
    url: 'SendMail/SendEmail',
    data: data,
    method: 'post'
  });
}